<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="toolbar"/>
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Complementos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="end" class="mr-1">
              <v-query-builder :query-map="rules" model="addon" class="mr-1" />
              <v-btn @click="dialogAddon=true" color="secondary" outlined><v-icon left small>mdi-plus</v-icon>Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="table"/>
          <template v-else>
            <v-col v-if="!addonsList.length" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
              <span class="d-block subtitle-1">Aún no tienes complementos para suscribir</span>
              <v-btn class="my-5" @click="dialogAddon=true" outlined>Crear un complemento</v-btn>
            </v-col>
            <template v-else>
              <v-data-table :headers="headers" :items="addonsList" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(addonsList) => {$router.push({ name: 'AddonRetrieveUpdate', params: { id: addonsList.id }})}" style="cursor: pointer">
                <!-- header -->
                 <template v-slot:header="{ props: { headers } }">
                    <VTableHeaders :headers="headers" @sort="setSort" />
                 </template>
                 <!-- end header -->
                <template v-slot:[`item.name`]="{ item }">
                  <span class="text--secondary font-weight-medium">{{item.name}}</span>
                </template>
                <template v-slot:[`item.apply_scheme`]="{ item }">
                  <span>{{item.apply_scheme === 'recurring' ? 'Recurrente' : 'Una vez'}}</span>
                </template>
                <template v-slot:[`item.duration_times`]="{ item }">
                  <span>{{item.apply_scheme === 'recurring' ? item.duration_times : 1}}</span>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <span class="text--secondary font-weight-medium" v-if="addonsList">{{item.amount | number(item.currency.rounded)}}</span> <span>{{item.currency.id}}</span>
                </template>
                <template v-slot:[`item.created`]="{ item }">
                  <span>{{item.created | dateTime}}</span>
                </template>
              </v-data-table>
              <template v-if="showPagination || showAll">
                <v-divider />
                <v-row class="mx-0" align="center">
                  <template v-if="showPagination">
                    <v-col cols="6">
                      <span class="body-2 text--secondary">{{count}} registros</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                    </v-col>
                  </template>
                </v-row>
              </template>
            </template>
          </template>
        </v-card-text>
      </v-card>

      <!-- dialog new customer -->
      <v-dialog v-model="dialogAddon" width="600" persistent no-click-animation scrollable>
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear un complemento</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn class="ml-3" @click="dialogAddon=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-0 background-card">
            <v-list class="v-list-form py-6 transparent">
              <v-list-item>
                <v-list-item-title>Nombre</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="8">
                    <v-text-field v-model.trim="$v.newAddon.name.$model" :error="$v.newAddon.name.$error" background-color="white" outlined required single-line dense maxlength="56" placeholder="Escribe un nombre" hide-details/>
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Descripción</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-text-field v-model.trim="$v.newAddon.description.$model" :error="$v.newAddon.description.$error" background-color="white" outlined required single-line dense maxlength="256" placeholder="Escribe una descripción" hide-details/>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="mt-4">
                <v-list-item-title>
                  <span class="text--secondary font-weight-medium">Precio</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="mt-2">
                <v-list-item-title>Moneda</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="9">
                    <v-select v-model="$v.newAddon.currency.$model" :error="$v.newAddon.currency.$error" :items="currencies" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                      <template v-slot:item="data">
                        <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                      </template>
                    </v-select>
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Precio</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="6">
                  <v-text-field v-model.number="$v.newAddon.amount.$model" :error="$v.newAddon.amount.$error" :suffix="$v.newAddon.currency.$model" background-color="white" outlined required single-line dense hide-details/>
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="mt-4">
                <v-list-item-title>
                  <span class="text--secondary font-weight-medium">Tipo de cargo</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="mt-2">
                <v-list-item-title>Tipo</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="5">
                    <v-select v-model="$v.newAddon.apply_scheme.$model" :error="$v.newAddon.apply_scheme.$error" :items="item" item-value="value" item-text="name" :value="newAddon.apply_scheme" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="newAddon.apply_scheme === 'recurring'">
                <v-list-item-title>Ciclos</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="8">
                    <v-text-field v-model.number="$v.newAddon.duration_times.$model" :error="$v.newAddon.duration_times.$error" suffix="ciclos de facturación" background-color="white" outlined required single-line dense  hide-details/>
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>

              <!-- more options -->
              <v-list-item class="mt-6">
                <v-list-item-title>
                  <span class="text--secondary font-weight-medium">Otras opciones</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="my-3">
                <v-list-item-title>Código</v-list-item-title>
                <v-list-item-subtitle>
                  <v-col cols="6">
                    <v-text-field id="it-plan-sku" v-model.trim="$v.newAddon.sku.$model" :error="$v.newAddon.sku.$error" background-color="white" outlined required single-line dense maxlength="32" persistent-hint hide-details />
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="my-3">
                <v-list-item-title>Unidad</v-list-item-title>
                <v-list-item-subtitle>
                  <v-col cols="6">
                    <v-text-field id="it-plan-unit_label" v-model.trim="$v.newAddon.unit_label.$model" :error="$v.newAddon.unit_label.$error" background-color="white" placeholder="Etiqueta de unidad" outlined required single-line dense maxlength="4" persistent-hint hide-details />
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <!-- end more options -->
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn @click="dialogAddon=false" outlined color="secondary">Cancelar</v-btn>
            <v-btn @click="postAddon" :loading="$store.state.subscriptions.createLoader" color="primary">Crear complemento</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end dialog new customer -->
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, minValue, maxValue, maxLength, decimal, integer } from 'vuelidate/lib/validators'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VQueryBuilder,
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
      item: [
        { name: 'Una vez', value: 'one_time' },
        { name: 'Recurrente', value: 'recurring' }
      ],
      newAddon: {
        amount: null,
        apply_scheme: 'one_time',
        currency: null,
        description: '',
        duration_times: null,
        name: '',
        sku: null,
        unit_label: null
      },
      dialogAddon: false,
      rules: [
        {
          type: 'text',
          id: 'name',
          label: 'Nombre',
          operators: ['contiene']
        },
        {
          type: 'numeric',
          id: 'amount',
          label: 'Precio',
          operators: ['es igual', 'es menor a', 'es mayor a']
        },
        {
          type: 'select',
          id: 'apply_scheme',
          label: 'Tipo de cargo',
          choices: [
            {value: 'one_time', label: 'Una vez'},
            {value: 'recurring', label: 'Recurrente'}
          ]
        }
      ],
      headers: [
        { text: 'Nombre', value: 'name', width: 300, sortable: true},
        { text: 'Tipo de cargo', value: 'apply_scheme', align: 'start', class: 'font-weight-bold', width: 150, sortable: false },
        { text: 'Ciclos de facturación', value: 'duration_times', class: 'font-weight-bold', align: 'end', width: 160, sortable: false },
        { text: 'Precio', value: 'amount', align: 'end', width: 140, sortable: true},
        { text: 'Creado el', value: 'created', align: 'end', width: 200, sortable: true}
      ]
  }),
  computed: mapState({
    account: state => state.auth.account.id,
    count: state => state.subscriptions.addonsCount,
    addonsList: state => state.subscriptions.addonsList
  }),
  methods: {
    getList () {
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'addons',
        query: this.$route.query
      })
    },
    postAddon () {
      this.$v.newAddon.$touch()
      if (this.$v.newAddon.$invalid) {
        return false
      }
      this.$store.dispatch('subscriptions/CREATE', {
        resource: 'addons',
        payload: this.newAddon
      })
      .then((response) => {
        this.dialogAddon = false
        this.$router.push({
          name: 'AddonRetrieveUpdate',
          params: {
            id: response.data.id
          }
        })
      })
      .catch(() => {
        this.$dialog.message.error('Error al crear el complemento.')
      })
    }
  },
  validations: {
    newAddon: {
      name: {
        required,
        maxLength: maxLength(56)
      },
      description: {
        required,
        maxLength: maxLength(256)
      },
      currency: {
        required
      },
      amount: {
        required,
        decimal
      },
      apply_scheme: {
        required
      },
      duration_times: {
        required: requiredIf(function () {
          return this.newAddon.apply_scheme === 'recurring'
        }),
        integer,
        minValue: minValue(2),
        maxValue: maxValue(120)
      },
      sku: {
        maxLength: maxLength(32)
      },
      unit_label: {
        maxLength: maxLength(4)
      }
    }
  }
}
</script>
<style scoped>
::v-deep .v-datatable thead th.column.sortable.active.desc .no-rotate {
    transform: none !important;
}
</style>